<template>
  <div :data-attr="input.id">
    <legend v-if="input.name && (input.type !== $options.INPUT_TYPE.DROPDOWN && input.type !== $options.INPUT_TYPE.TEXT)" class="label">
      {{nameTranslate(input)}}<span style="white-space: nowrap;">&#160;<v-tooltip right max-width="330" v-if="input.tooltip">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" tag="span" fab><v-icon class="sr-icon-help"/></v-btn>
        </template>
      <span v-html="input.tooltip[lang.toLowerCase()]"></span>
      </v-tooltip>:
      </span>
    </legend>

    <v-checkbox
        v-if="input.type === $options.INPUT_TYPE.CHECKBOX"
        v-model="configOption"
        :ripple="false"
        color="primary"
        @change="emitValue($event)"
    >
      <template v-slot:label>
        <span>{{ nameTranslate(input.opts[0])}}
          <template v-if="getInputPrice(input.opts[0].billingcycles)">
              – <span class="price" v-html="priceTransform(getInputPrice(input.opts[0].billingcycles), currencyInfo.suffix, '', currencyInfo.prefix)"></span>
            </template>
        </span>
      </template>
    </v-checkbox>

    <v-radio-group
        v-else-if="input.type === $options.INPUT_TYPE.RADIO"
        :value="filteredOptions[0]"
        v-model="configOption"
        @change="emitValue($event)"
    >
      <v-radio
          v-for="item in filteredOptions"
          :key="item.id"
          :label="nameTranslate(item)"
          :value="item"
          :disabled="input.id === 'diskType' && Number(item.id) === 2 ? isDisabledNvm : undefined"
          @click="changeValue(item)"
      >
        <template v-slot:label>
          <span>{{ nameTranslate(item) }}
            <template v-if="getInputPrice(item.billingcycles)">
              – <span class="price" v-html="priceTransform(getInputPrice(item.billingcycles), currencyInfo.suffix, '', currencyInfo.prefix)"></span>
            </template><span style="white-space: nowrap;">&#160;<v-tooltip right max-width="330" v-if="item.tooltip">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    tag="span"
                    fab
                    @click.stop="$event.preventDefault()"
                >
                  <v-icon class="sr-icon-help"/>
                </v-btn>
              </template>
              <span v-html="item.tooltip[lang.toLowerCase()]"></span>
            </v-tooltip>
            </span>
          </span>
        </template>
      </v-radio>
    </v-radio-group>

    <v-select
        v-else-if="input.type === $options.INPUT_TYPE.DROPDOWN"
        :value="filteredOptions[0]"
        outlined
        :ref="nameTransform"
        :items="filteredOptions"
        item-value="id"
        :class="nameTransform"
        :attach="`.${nameTransform}`"
        :label="nameTranslate(input)"
        @change="emitValue($event)"
        return-object
        v-model="configOption"
        :noDataText="$t('noDataAvailable')"
        :rules="rulesConfigOption"
        :menu-props="{ bottom: true, offsetY: true }"
    >
      <template slot="selection" slot-scope="{ item }">{{ nameTranslate(item) }}</template>
      <template slot="item" slot-scope="{ item }">
          <span>{{ nameTranslate(item)}}
            <template v-if="getInputPrice(item.billingcycles)">
              – <span class="price" v-html="priceTransform(getInputPrice(item.billingcycles), currencyInfo.suffix, '', currencyInfo.prefix)"></span>
            </template>
          </span>
      </template>
    </v-select>

    <v-text-field
        v-else-if="input.type === $options.INPUT_TYPE.TEXT || isQty"
        v-model="configOption"
        :label="isQty ? undefined : nameTranslate(input)"
        outlined
        @input="emitValue($event)"
        :readonly="inputReadonly"
    >
      <template slot="append" v-if="isQty">
        <b v-html="'x ' + priceTransform(currencyInfo.rate, currencyInfo.suffix, '', currencyInfo.prefix)"></b>
      </template>
    </v-text-field>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { SETTINGS_GETTERS } from "@/store/modules/settings";
  import { CART_GETTERS, CART_MUTATIONS } from "@/store/modules/cart-context";
  import { DOMAIN_TYPE, INPUT_TYPE, LANG, PROMO } from '@/constants';
  import { priceTransform } from '@/modules/priceTransform';
  import { nameTranslate } from '@/modules/nameTranslate';

  export default {
    name: "ConfigOption",
    INPUT_TYPE,
    props: {
      currencyInfo: { type: [Object, Array], default: () => ({}) },
      input: { type: [Object, Array], default: () => ({}) },
      paymentPeriod: { type: [Object, Array], default: () => ({}) },
      dependsOn: { type: [Object, Array], default: () => ([]) },
      domainType: { type: String },
      isWordpressV3: { type: Boolean, default: false }
    },
    data: () => ({
      isInputPrice: false,
      inputPrice: undefined,
      configOption: {},
      qtyDefault: '20',
      isDisabledNvm: true,
      cartContextSnapshot: null
    }),
    async mounted() {
      if (!this.lang) { this.lang =  await this.setLang(); };
      if (!this.cartContext) { this.cartContext = this.setCartContext(); }
    },
    created() {
      this.configOption = this.input.type === INPUT_TYPE.CHECKBOX ? false : this.input.opts[0];
      if(this.isQty) {
        if(this.$route.query.units) {
          this.configOption = this.$route.query.units;
        }
        if(this.$route.query.promo === PROMO.CLOUDTEST$1) {
          this.configOption = this.qtyDefault
        }
      }
      if(this.isWordpressV3 && Number(this.input.id) === 46) {
        this.configOption = this.input.opts.find(opt => Number(opt.id) === 194);
      }
      this.emitValue(this.configOption);
    },
    computed: {
      ...mapGetters('settings', {
        currency: SETTINGS_GETTERS.CURRENCY,
        lang: SETTINGS_GETTERS.LANG
      }),
      ...mapGetters('cartContext', {
        cartContext: CART_GETTERS.CART_CONTEXT,
      }),
      isQty() {
        return this.input.type === INPUT_TYPE.QTY;
      },
      inputReadonly() {
        return this.domainType === DOMAIN_TYPE.CLOUD && this.cartContext?.promo === PROMO.CLOUDTEST$1;
      },
      nameTransform() {
        return this.nameTranslate(this.input).replace(/ /g, '-');
      },
      filteredOptions() {
        let options = this.input.opts;
        if(this.dependsOn && this.dependsOn.length > 0) {
          options = this.input.opts.filter(item => this.dependsOn.includes(item.id));
        }
        return options
      },
      rulesConfigOption() {
        const rules = this.$attrs.rules || [];
        rules.push(v => !!v || this.$t('validation.required'));

        return rules;
      },
      qtyMax() {
        return this.input?.qtymaximum || '2000';
      },
      qtyMin() {
        return this.input?.qtyminimum || '1';
      }
    },
    methods: {
      priceTransform,
      nameTranslate,
      getInputPrice(input) {
        const billingcycle = input?.find(item => item.currency_code === this.currency && item.period === this.paymentPeriod.period);
        return billingcycle && billingcycle.price && billingcycle.price > 0 ? billingcycle.price : undefined;
      },
      changeValue(item) {
        if(this.input.id === 'diskType' && item.id === 1) {
          this.cartContextSnapshot.products[0].config_opts.diskType = 1;
          this.configOption = this.input.opts[0];
        }
      },
      emitValue(value) {
        let val = value;
        let inputPrice = 0;

        if(this.input.type === INPUT_TYPE.CHECKBOX) {
          val = this.configOption;

          if(this.configOption) {
            inputPrice = this.getInputPrice(this.input.opts[0].billingcycles)
          }
        } else if(this.input.type === INPUT_TYPE.QTY) {
          inputPrice = Number(val) * Number(this.currencyInfo.rate)
        } else {
          val = value ? value.id : undefined;
          inputPrice = value ? this.getInputPrice(value.billingcycles) : 0;
        }

        this.$emit('input', val);
        const obj = {
          id: this.input.id,
          legend: this.nameTranslate(this.input),
          name: value ? this.nameTranslate(value) : undefined,
          price: inputPrice || 0,
          qty: this.input.type === INPUT_TYPE.QTY ? Number(val) : undefined
        }

        this.$store.commit(`cartContext/${CART_MUTATIONS.SET_CART_EXTRA}`, { hostingItem: obj });
      },
      eventHandler(val) {
        this.$nextTick(() => {
          this.configOption = val?.toString().replace(/\D/g, '');
        });

        clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
          if(Number(this.configOption) > this.qtyMax) {
            this.configOption = this.qtyMax
          }
          if(Number(this.configOption) < this.qtyMin) {
            this.configOption = this.qtyMin
          }
        }, 700)
      }
    },
    watch: {
      currencyInfo: {
        handler() {
          this.emitValue(this.configOption);
        },
        deep: true
      },
      paymentPeriod() {
        this.emitValue(this.configOption);
      },
      configOption(obj) {
        if(this.isQty) { this.eventHandler(obj) }

        if(!obj && this.input.type === (INPUT_TYPE.RADIO || INPUT_TYPE.DROPDOWN)){
          this.configOption = this.filteredOptions[0];
        };

        this.$emit('emitDependsOn', obj ? obj.dependent_options : this.configOption);
      },
      dependsOn(val) {
        if(val && val.length > 0) {
          if(!this.filteredOptions.some(item => item.id === this.configOption.id)) {
            this.configOption = this.filteredOptions[0];
          }
        }
      },
      inputReadonly(val) {
        if(val) { this.configOption = this.qtyDefault }
      },
      cartContext: {
        handler(newValue) {
          if (!this.isWordpressV3) return;

          const product = this.cartContext?.products[0];

          if (product && product.config_opts) {
            const locationId = product.config_opts["46"];
            const { diskType } = product.config_opts || {};

            if (locationId === 194 && this.input.id === 'diskType') {
              this.isDisabledNvm = true;
              this.configOption = this.input.opts[0]

            } else if (locationId === 195) {
              this.isDisabledNvm = false;

              if(this.input.id === 'diskType') {
                const previousSnapshot = this.cartContextSnapshot;
                const currentSnapshot = JSON.parse(JSON.stringify(newValue));
                if(previousSnapshot &&
                  previousSnapshot.products[0].config_opts.diskType === 2
                ) {
                  this.configOption = this.input.opts[1]
                }
                this.cartContextSnapshot = currentSnapshot;
              }
            }
          }
          this.emitValue(this.configOption);
        },
        immediate: true,
        deep: true
      },
    }
  }
</script>

<style lang="scss">
  .v-radio--is-disabled {
    opacity: .5;
  }
</style>
